export const SensitivityTableTypes = {
  AverageWellsDrilledSensitivities: 'averageWellsDrilledSensitivities',
  EffectiveDateSensitivities: 'effectiveDateSensitivities',
  PriceDeckSensitivities: 'priceDeckSensitivities',
  EurRiskSensitivities: 'eurRiskSensitivities',
} as const;

export type SensitivityTableTypes =
  (typeof SensitivityTableTypes)[keyof typeof SensitivityTableTypes];
